import React from 'react';

const DebugUrlSwitcher = ({ position = "top-left", isCollapsible = true }) => {
  // Hide component completely from both development and production
  return null;
};

export default DebugUrlSwitcher;
